<tui-loader
  class="text-slate-300"
  data-testid="spinner"
  size="m"
  [class.invisible]="!isVisible"
  [inheritColor]="true"
  [showLoader]="true"
>
  <span class="invisible">oooo</span>
</tui-loader>
